import { Label, TextInput } from 'flowbite-react'
import React, { useContext, useEffect, useState } from 'react'
import { FaArrowRight, FaEye, FaEyeSlash } from 'react-icons/fa'
import logo from '../../assets/Ideos.png'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import PublicLayout from '../../layouts/PublicLayout'
import loginStyles from './Login.module.scss'
import * as styles from './Login.styles'
import Form from '../../components/Form/Form'
import CustomInput from '../../components/CustomInputs/CustomInput'
import CustomButton from '../../components/CustomButton/CustomButton'
import CustomLink from '../../components/CustomLinks/CustomLink'
import bottomLines from '../../assets/botton lines.png'
import api from '../../api'
import showToast from '../../components/CustomToast/toastHelper'
import { UserContext } from '../../contexts/UserContext'
import client from '../../api/client'
interface LoginInputs {
    email: string,
    password: string
}
const Login = () => {
    const { userDetails, setUserDetails, fetchUser } = useContext(UserContext) ?? {}

    const navigate = useNavigate()

    const [formValues, setFormValues] = useState<LoginInputs>({
        email: '',
        password: ''
    })
    const [showPassword, setShowPassword] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [isFormValid, setIsFormValid] = useState<boolean>(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value.trim()
        }));
    }

    useEffect(() => {
        const isEmailValid = formValues.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        const isPasswordValid = formValues.password.length > 0;
        if (isEmailValid && isPasswordValid) {
            setIsFormValid(true)
        }
        else {
            setIsFormValid(false);
        }
    }, [formValues]);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }


    const handleLogin = async (e: any) => {
        e.preventDefault()
        setLoading(true)
        try {
            const signInResponse = await api.signIn({ Email: formValues.email, Password: formValues.password })
            if (signInResponse.data.status == "success") {
                //sessionStorage.setItem("accessToken", signInResponse.data.token.accessToken)

                //setUser(signInResponse.data.user)
                // sessionStorage.setItem('user', signInResponse.data.user)
                // let status = signInResponse.data.subsidiaryDetails.subsidiaries[0].status);
                const { message, statusCode } = signInResponse.data
                if (statusCode === "000") {
                    navigate('/complete/login', { state: { email: formValues.email, mesage: message } })
                    showToast(message, "success")
                }
                else {
                    sessionStorage.setItem("accessToken", signInResponse.data.token.accessToken)
                    navigate('/overview')
                }
                setLoading(false)
            }
            else {
                setLoading(false)
                showToast(signInResponse.data, "error")
            }
        }
        catch (err: any) {
            console.error('Sign in error', err)
            setLoading(false)
            showToast(err.response.data.message, "error")
        }
    }
    return (
        <PublicLayout>
            <div className={styles.container}>
                <div className={styles.formContainer }>

                    <Form title="Login" subtitle="Kindly enter your details to access your account">

                        <CustomInput label='Email address' value={formValues.email} name='email' onChange={handleChange} />
                        <CustomInput label='Password' name='password' type={showPassword ? 'text' : 'password'} value={formValues.password} onChange={handleChange} onRightIconClick={() => togglePasswordVisibility()} rightIcon={showPassword ? FaEye : FaEyeSlash} />
                        <p className={styles.forgotPara}><CustomLink to="/forgot-password" text="Forgot password" /></p>
                        <CustomButton className={styles.button} disabled={isFormValid || loading ? false : true} text='Sign in' onClick={handleLogin} loading={loading} icon={<FaArrowRight />} />
                        <div className={styles.buttomDiv}>
                            <p className={styles.buttomDivPara}>Don't have an account?
                                <CustomLink className={styles.link} to="/register" text=" Create an account" /></p>
                        </div>

                    </Form>
                    {loading && (
                        <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
                            <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                        </div>
                    )}
                </div>

            </div>

        </PublicLayout>
    )
}

export default Login

